import { Toggle } from "./fields";

// Show/hide the main homepage blocks. id must match Site.jsx BLOCKS + sectionsVisibility.
const BLOCKS = [
  { id: "latestNews", label: "Dernières actualités (accueil)" },
  { id: "stats", label: "Statistiques" },
  { id: "mission", label: "Mission" },
  { id: "association", label: "L'Association" },
  { id: "activities", label: "Nos activités" },
  { id: "realisations", label: "Réalisations" },
  { id: "festival", label: "Festival" },
  { id: "news", label: "Actualités (section complète)" },
  { id: "formations", label: "Formations" },
  { id: "team", label: "Équipe" },
  { id: "testimonials", label: "Témoignages" },
  { id: "partners", label: "Partenaires" },
  { id: "contact", label: "Contact" },
];

export const AdminBlocks = ({ value = {}, onChange }) => {
  const vis = value || {};
  const set = (id, on) => onChange({ ...vis, [id]: on });
  return (
    <div className="space-y-3" data-testid="admin-blocks">
      <div className="rounded-lg border border-electric/20 bg-[#0a0a0a] p-4 text-sm text-secondary2">
        Affichez ou masquez les blocs de la page d'accueil. Un bloc masqué disparaît proprement du site (la page se réorganise sans laisser d'espace vide). Le Hero reste toujours visible.
      </div>
      {BLOCKS.map((b) => (
        <div key={b.id} className="flex items-center justify-between rounded-lg border border-white/10 bg-[#0a0a0a] px-4 py-3" data-testid={`block-toggle-${b.id}`}>
          <span className="text-sm text-white">{b.label}</span>
          <Toggle label={vis[b.id] === false ? "Masqué" : "Affiché"} hint="Affiche ou masque ce bloc sur le site sans le supprimer. La page se réorganise automatiquement." checked={vis[b.id] !== false} onChange={(on) => set(b.id, on)} />
        </div>
      ))}
    </div>
  );
};
